import script from "./PaymentMethodModal.vue?vue&type=script&setup=true&lang=js"
export * from "./PaymentMethodModal.vue?vue&type=script&setup=true&lang=js"

import "./PaymentMethodModal.vue?vue&type=style&index=0&id=03fc9aeb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-03fc9aeb"]])

export default __exports__